<template>
  <v-container class="hrtc">
    <v-progress-linear v-if="!rtcMessage(message.conversation_id, message.body)" indeterminate color="accent darken-2"></v-progress-linear>
    <v-card v-else min-width="350px" outlined>
      <v-card-title>HearRo Call</v-card-title>
      <v-card-subtitle>
        {{ rtcState(rtcMessage) }}
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <!-- <v-row>Participants</v-row>
          <v-row>one, two, three</v-row> -->
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="(rtcState(rtcMessage) === 'Active')" @click="join">Join</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'RTCMessage',
  data () {
    return {
      loading: true,
      rtcSession: {}
    }
  },
  mounted () {
    this.$store.dispatch('hearro/getRTCSession', { conversationId: this.message.conversation_id, sessionId: this.message.body })
  },
  methods: {
    formatStarted (started) {
      return moment(started).format('MMM Do YYYY')
    },
    rtcState (message) {
      if (message.state) {
        switch (message.state) {
        case 1:
          return 'Locked'
        case 2:
          return 'Finished'
        case 3:
          return 'Archived'
        }
      }
      return 'Active'
    },
    join () {
      console.log('emit join')
      this.$emit('joinRTC', this.message.body)
    }
  },
  props: { message: Object },
  computed: {
    ...mapGetters({
      rtcMessage: 'hearro/conversationRTCMessage'
    })
  }
}
</script>

<style scoped>
.hrtc {
  max-width: 50%;
  margin: 0;
}
</style>
